import { render } from "./AccountPackageDinnerAvailability.vue?vue&type=template&id=3215e0ca&scoped=true"
import script from "./AccountPackageDinnerAvailability.vue?vue&type=script&lang=js"
export * from "./AccountPackageDinnerAvailability.vue?vue&type=script&lang=js"

import "./AccountPackageDinnerAvailability.vue?vue&type=style&index=0&id=3215e0ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3215e0ca"]])

export default __exports__